// The API's cap on an admin reason or note, the same 500 on every column one
// is stored in (DomainConstraint OrganizationStatusHistory.Reason,
// OrderStatusHistory.Notes, Location.RejectionReasonNotes). Every admin dialog
// sends the reason trimmed, so the cap applies to the trimmed text and padding
// never counts.
export const REASON_MAX_LENGTH = 500;

export type ReasonProblem = "missing" | "too-long";

// Why a typed reason can't be sent yet, or null when it can.
export const reasonProblem = (
    reason: string,
    required: boolean,
): ReasonProblem | null => {
    const trimmed = reason.trim();

    if (required && trimmed.length === 0) {
        return "missing";
    }

    return trimmed.length > REASON_MAX_LENGTH ? "too-long" : null;
};
